import React, { useState } from 'react';
import {DropzoneArea} from 'material-ui-dropzone'

let ResumeDropZone = (props: any) => {
  const [files, setFiles] = useState<File[]>([]);

  let onChange = (files: File[]) => {
    setFiles(files);
    if(props.onChange) {
      props.onChange(files);
    } 
  }

  let opts = Object.assign({
    acceptedFiles: ['.doc, .docx, .pdf, .odt, .rtf, .txt, .epub, .zip'],
    showPreviews: false,
    maxFileSize: 5000000,
    filesLimit: 1,
    dropzoneText: 'Drag and drop or click...',
    onChange: onChange,
    inputProps: {className: props.className}
  }, props);
  // console.log(files);
  return (
    <DropzoneArea {...opts}/>
  )
}
 
export default ResumeDropZone;